import {
  MESSAGING_PROMPT_REQUEST_EVENT,
  MESSAGING_PROMPT_REQUEST_STORAGE_KEY,
  messagingPromptRequestSchema,
  type MessagingPromptRequest,
} from "@/lib/messagingPromptRequest";

/** Persists a contextual prompt request so it survives guest conversion and onboarding. */
export function requestMessagingPrompt(input: Omit<MessagingPromptRequest, "requestedAt">) {
  if (typeof window === "undefined") return;

  const request = messagingPromptRequestSchema.parse({ ...input, requestedAt: Date.now() });
  try {
    window.localStorage.setItem(MESSAGING_PROMPT_REQUEST_STORAGE_KEY, JSON.stringify(request));
  } catch {
    // Storage may be unavailable; keep automatic contextual prompting suppressed.
  }
  window.dispatchEvent(new Event(MESSAGING_PROMPT_REQUEST_EVENT));
}
